import { types } from 'mobx-state-tree'
import { FORM_MESSAGE } from '../../utils/constants'

const Message = types
  .model('Message', {
    value: types.string,
    type: types.string,
    code: types.string,
  })
  .actions((self) => ({
    setMessage(value: string, type = 'NEGATIVE', code?: string) {
      self.value = value.toString()
      self.type = type
      self.code = code ?? ''
    },
    resetMessage() {
      self.value = ''
      self.type = 'NEGATIVE'
      self.code = ''
    },
  }))
  .views((self) => ({
    getMessage(): any {
      return {
        value: self.value,
        type: self.type,
        code: self.code,
      }
    },
    getFormMessage() {
      return self.code === FORM_MESSAGE ? self.value : ''
    },
  }))

export { Message }
